import React from "react" 
import { Plus } from "lucide-react"
import { cn } from "lib/utils"


export default function GridTableTitle({
  addItemFn,
  title,
  className="",
}:{
  addItemFn?: () => void;
  title: string;
  className?: string;
}){

  return (
    <div className={cn("w-full flex justify-between items-center bg-slate-700 px-2 py-1", className)}>
      <h3 className="text-sm uppercase tracking-wider">{ title }</h3>
      { addItemFn !== undefined && (
        <Plus className="size-5 cursor-pointer stroke-1 stroke-gray-100" onClick={addItemFn} />
      )}
    </div>
  )
}